@if (model()) {
<div class="client-node" [id]="model()!.node._id">
    <div class="node-bar">
        <div class="node-nav" (click)="onToggle()">
            @if (model()!.children && model()!.solo.expanded) {
            <mat-icon>expand_more</mat-icon>
            }
            @if (model()!.children && !model()!.solo.expanded) {
            <mat-icon>chevron_right</mat-icon>
            }
        </div>
        <div class="node-nav">
            <mat-icon matBadge="&#8288;" matBadgeSize="small" matBadgePosition="before"
                [matBadgeHidden]="!model()!.node.isNew && !model()!.node.isDirty" aria-hidden="false">{{icon}}</mat-icon>
        </div>
        <!-- <i *ngIf="node.children" [ngClass]="expanded ? 'chevron down' : 'chevron right'" (click)="onToggle(node)"></i> -->
        <div class="node-info" tabindex="-1" [ngClass]="{'no-chevron': !model()!.children, 'active': model()!.solo.active}"
            (focus)="onFocus()" (contextmenu)="onMenu($event)">
            <div class="node-name">
                <input #name class="input-text" [(ngModel)]="model()!.node.name"
                    [disabled]="!(model()!.solo.editing && model()!.solo.active)" />
            </div>
            <div class="node-edit"
                [hidden]="!model()!.solo.editable || model()!.solo.editing && model()!.solo.active || !model()!.node.parentId"
                (click)="onEdit()"><mat-icon>keyboard</mat-icon></div>
            <div class="node-save" [hidden]="!(model()!.solo.editing && model()!.solo.active)" (click)="onSave()">
                <mat-icon>check</mat-icon>
            </div>
            <div class="node-cancel" [hidden]="!(model()!.solo.editing && model()!.solo.active)" (click)="onCancel()">
                <mat-icon>close</mat-icon>
            </div>
        </div>
    </div>
    <ul cdkDropList [cdkDropListData]="model()" (cdkDropListDropped)="onDrop($event)" [hidden]="!model()!.solo.expanded">
        @for (descent of model()!.descents; track descent.node._id) {
        <li>
            @if (descent.solo.canDrag) {
            <app-client-node cdkDrag cdkDragBoundary=".client-tree"
                [cdkDragDisabled]="descent.solo.editing || !descent.solo.active" [cdkDragData]="descent"
                [model]="descent"></app-client-node>
            }
            @if (!descent.solo.canDrag) {
            <app-client-node [model]="descent"></app-client-node>
            }
        </li>
        }
        @for (child of model()!.children; track child.node._id) {
        <li>
            @if (child.solo.canDrag) {
            <app-client-node cdkDrag cdkDragBoundary=".client-tree"
                [cdkDragDisabled]="child.solo.editing || !child.solo.active" [cdkDragData]="child"
                [model]="child"></app-client-node>
            }
            @if (!child.solo.canDrag) {
            <app-client-node [model]="child"></app-client-node>
            }
        </li>
        }
    </ul>
</div>
}
